import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dt-mainCard"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_ContentComponent = _resolveComponent("ContentComponent")!
  const _component_PageLoader = _resolveComponent("PageLoader")!

  return ($data.card)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_HeaderComponent, {
          header: $data.card.header,
          "page-identity": $props.pageIdentity,
          "go-back": $options.goBack,
          onApplyFilter: $options.onApplyFilter
        }, null, 8 /* PROPS */, ["header", "page-identity", "go-back", "onApplyFilter"]),
        _createVNode(_component_ContentComponent, { card: $data.card }, null, 8 /* PROPS */, ["card"])
      ]))
    : (_openBlock(), _createBlock(_component_PageLoader, { key: 1 }))
}